import React from 'react';
import PropTypes from "prop-types";
import stringReplace from 'react-string-replace'

import { withError } from '../../../shared/components/error-boundary';
import Countdown from '../../../shared/components/countdown';

import './intra-day-banner.less';

export class IntraDayBanner extends React.PureComponent{
    static defaultProps = {
        deals: {},
        dateFormat: "d? h? m? s?",
        message: null
    }

    getCountDown = (activeDeal) =>{
        const { limit, unitsLeft, startDate, endDate } = activeDeal;

        if(unitsLeft >= 0){
            return (
                <React.Fragment>
                    <span className="units-left">{unitsLeft}</span> Units left at this price
                </React.Fragment>

            );
        }else{
            return <Countdown endtime={endDate} format={this.props.dateFormat}/>;
        }

    }

    render(){
        const { deals, message, className } = this.props;
        const { activeDeal={} } = deals;
        const { limit, unitsLeft, startDate } = activeDeal;
        const defaultMessaging = (limit > -1 ? '{limit} Unit Flash Sale' : 'Flash Sale Ending Soon');
        let displayMsg = message || defaultMessaging;
        let invalidMatch = false;

        //match limit
        displayMsg = stringReplace(displayMsg, new RegExp(/\{limit}/g), (match, i, offset) => {
            if(limit === -1){
                invalidMatch = true;
            }
            return <React.Fragment  key={`redemption-limit-${i}`}><span className="redemption-limit">{limit}</span>{match}</React.Fragment>;
        });

        //match unitsLeft
        displayMsg = stringReplace(displayMsg, new RegExp(/\{unitsLeft}/g), (match, i, offset) => {
            if(unitsLeft === -1){
                invalidMatch = true;
            }
            return <React.Fragment key={`units-left-${i}`}><span className="units-left">{unitsLeft}</span>{match}</React.Fragment>;
        });

        //if macro was inputed for a value that has not been set for this promotion
        //fallback to default messaging
        if(invalidMatch){
            displayMsg = defaultMessaging;
        }

        return (
            <div className={`deals-banner${className ? ' ' + className : ''}`}>
                <span className="deals-callout">{displayMsg}</span>
                <span className="deals-countdown">{this.getCountDown(activeDeal)}</span>
            </div>
        );
    }
}

class IntraDayDeals extends React.PureComponent {

    static propTypes = {
        itemId: PropTypes.string
    };

    static defaultProps = {
        itemId: null
    }

    componentDidMount(){
        const { itemId } = this.props;
        if(itemId){
            this.props.fetchDeals(itemId);
        }
    }

    componentDidUpdate(prevProps) {
        let { userIdle, itemId } = this.props;
        //fetch new deals if itemId changed, or if user came back from being idle
        if (itemId !== prevProps.itemId || (!userIdle && prevProps.userIdle)) {
            this.props.fetchDeals(itemId, prevProps.userIdle);
        };
    }


    render() {
        const { productDeals={}, isDealActive } = this.props;
        const isActive = isDealActive(productDeals)

        if(this.props.children){
            return this.props.children({
                isActive,
                productDeals,
                IntraDayBanner
            })
        }else{
            return null;
        }
    }
}

export default withError(IntraDayDeals);
